module.exports = __webpack_public_path__ + "img/20200808_180906.c808ff45.jpg";